I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "about": {
    "company": {
      "description": "Independent credit broker working in your interest – we compare multiple lenders to find the most favorable offer.",
      "title": "Trusted Partner on Your Side"
    },
    "expertise": {
      "description": "No hidden terms. Clear, understandable and efficient – from application to approval.",
      "title": "Fast and Transparent Solutions"
    },
    "location": {
      "title": "How to Find Us"
    },
    "security": {
      "description": "We carefully store your information and cooperate only with licensed and verified partners.",
      "title": "Security and Confidentiality Guaranteed"
    },
    "subtitle": "We work to offer you the most suitable solution",
    "team": {
      "description": "We listen, understand and adapt – solutions based on your needs, not \"one size fits all\".",
      "title": "Individual Approach to Each Client"
    },
    "title": "About Us"
  },
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      }
    }
  },
  "anchor_links": {
    "about_us": "about-us",
    "business": "business-loan",
    "car": "car-leasing",
    "consumer": "consumer-loan",
    "contact": "contact",
    "faq": "frequently-asked-questions",
    "loan_application_form": "loan-application-form",
    "mortage": "mortgage"
  },
  "contact": {
    "additional_info": "Our team is ready to help you with any questions or concerns.",
    "address": "Bukultu iela 11, Riga, Latvia",
    "address_title": "Address",
    "company_info": {
      "address": {
        "title": "Address",
        "value": "Bukultu iela 11, Riga, Latvia"
      },
      "bank": {
        "title": "A/S \"Luminor Bank\"",
        "value": "LV47RIKO0002930366834"
      },
      "email": {
        "title": "Email",
        "value": "info@kreditiem.lv"
      },
      "hours": {
        "title": "Business Hours",
        "value": "Monday - Friday: 8:00 - 17:00"
      },
      "name": {
        "title": "A/S Baltijas investīciju attīstības fonds",
        "value": "40103550907"
      },
      "phone": {
        "title": "Phone",
        "value": "+371 251182216"
      },
      "title": "Company Information"
    },
    "copyright": "© 2024 AS Baltijas investīciju attīstības fonds. All rights reserved.",
    "cta": "Contact Us",
    "email": "info@kreditiem.lv",
    "email_title": "Email",
    "form": {
      "email": "Email",
      "message": "Message",
      "message_placeholder": "Your message...",
      "name": "Name",
      "phone": "Phone Number",
      "sending": "Sending...",
      "submit": "Send Message",
      "surname": "Surname",
      "title": "Contact Form"
    },
    "hours_title": "Business Hours",
    "hours_weekdays": "Monday - Friday: 8:00 - 17:00",
    "hours_weekend": "Saturday - Sunday: Closed",
    "messages": {
      "error": "Failed to send message. Please try again.",
      "success": "Message sent successfully!"
    },
    "phone": "+371 251182216",
    "phone_title": "Phone",
    "subtitle": "Get in touch with our team",
    "title": "Contacts"
  },
  "contact_mailer": {
    "question": "Question"
  },
  "cookie_consent": {
    "accept": "Accept All",
    "decline": "Decline",
    "message": "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
    "privacy_policy": "Read our Privacy Policy"
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "errors": {
    "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    },
    "unacceptable_request": "A supported version is expected in the Accept header.\n",
    "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
  },
  "faq": {
    "contact_text": "Still have questions? Our team is ready to help.",
    "eligibility": {
      "answer": "After a positive loan decision, funds can be credited to your account within a few hours or days – depending on the chosen lender and loan type.",
      "question": "How quickly can I receive money in my account?"
    },
    "process": {
      "answer": "Yes, in some cases a loan with collateral or guarantor can increase the chances of getting financing or getting better terms.",
      "question": "Is it possible to get a loan with a guarantor or collateral?"
    },
    "requirements": {
      "answer": "Yes, each case is evaluated individually. Some lenders also accept alternative income sources – such as self-employment or rental income.",
      "question": "Can I apply if I'm not officially employed?"
    },
    "subtitle": "Find answers to common questions about our loan process",
    "timeframe": {
      "answer": "Yes, credit history is taken into account, but we work with multiple lenders, including those that offer solutions for clients with previous late payment marks.",
      "question": "Does my credit rating affect the chances of getting a loan?"
    },
    "title": "Frequently Asked Questions"
  },
  "features": {
    "description": "We help find not only the best lender but also make the whole process fast, clear and secure – so the result truly matches your needs.",
    "flexible_terms": {
      "description": "Choose the most convenient term yourself",
      "title": "Flexible Terms"
    },
    "great_rates": {
      "description": "Choose what suits you best",
      "title": "Transparency"
    },
    "personal_support": {
      "description": "Knowledgeable credit specialists who will help",
      "title": "Personal Support"
    },
    "quick_approval": {
      "description": "Get a response within 1 business day",
      "title": "Quick Approval"
    },
    "quick_process": {
      "description": "Get a decision within 1 business day",
      "title": "Quick Process"
    },
    "secure_process": {
      "description": "Your data is protected with highest level security",
      "title": "Secure Process"
    },
    "title": "Why Choose Us?"
  },
  "floating_button": {
    "aria_label": "Go to loan application form",
    "text": "Apply Now"
  },
  "footer": {
    "business_hours": {
      "title": "Business Hours",
      "weekdays": "Monday - Friday: 8:00 - 17:00",
      "weekend": "Saturday - Sunday: Closed"
    },
    "contact": {
      "address": "Bukultu iela 11, Riga, Latvia",
      "address_title": "Address",
      "email": "info@kreditiem.lv",
      "email_title": "Email",
      "phone": "+371 25182216",
      "phone_title": "Phone",
      "subtitle": "Get in touch with our team",
      "title": "Contact Us"
    },
    "copyright": "© %{year} AS Baltijas investīciju un attīstības fonds. All rights reserved.",
    "disclaimer": "Scope of authority - independent broker.",
    "legal": {
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "title": "Legal Information"
    },
    "quick_links": {
      "about": "About Us",
      "contact": "Contact",
      "faq": "FAQ",
      "services": "Services",
      "title": "Quick Links"
    },
    "social": {
      "title": "Find Us On"
    }
  },
  "form": {
    "and": "and",
    "buttons": {
      "next": "Next",
      "previous": "Previous"
    },
    "documents_help": "To evaluate your application, please attach bank statements for the last 6 months.",
    "family_status": {
      "married": "Married",
      "single": "Single"
    },
    "fields": {
      "addresses_match": "My factual address matches the declared address",
      "agree_to_terms": "I agree to",
      "bank_account": "Bank Account Number (IBAN)",
      "city": "City / Town",
      "declared_address": "Declared Address",
      "dependent_persons": "Number of Dependent Persons",
      "email": "Email",
      "factical_address": "Factual Address",
      "family_status": "Family Status",
      "first_name": "First Name",
      "job_type": "Employment Type",
      "last_name": "Last Name",
      "loan_amount": "Loan Amount",
      "loan_period": "Loan Period",
      "loan_type": "Loan Type",
      "personal_code": "Personal Code",
      "phone": "Phone Number",
      "upload_documents": "For faster application processing, attach bank account statement"
    },
    "job_type": {
      "other": "Other",
      "permanent": "Permanent Work",
      "retired": "Retired",
      "self_employed": "Self-employed",
      "student": "Student",
      "temporary": "Temporary Work",
      "unemployed": "Unemployed"
    },
    "links": {
      "privacy_policy": "Privacy Policy",
      "terms": "Terms of Service"
    },
    "loan_types": {
      "business": "Business Loan",
      "car": "Car Leasing",
      "consumer": "Consumer Loan",
      "mortgage": "Mortgage"
    },
    "messages": {
      "error": "Error submitting application: %{message}",
      "file_upload_error": "Error uploading file: %{message}",
      "file_upload_max": "Maximum number of files reached",
      "file_upload_removed": "File removed",
      "file_upload_size": "File size exceeds limit",
      "file_upload_success": "File uploaded successfully",
      "file_upload_type": "Invalid file type",
      "loading": "Loading...",
      "network_error": "Network error. Please try again.",
      "processing": "Processing your application...",
      "saving": "Saving...",
      "success": "Application submitted successfully!",
      "success_subtitle": "We will contact you shortly",
      "uploading": "Uploading..."
    },
    "months": "months",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Enter your city",
      "personal_code": "123456-12345",
      "phone": "+371 12345678"
    },
    "sections": {
      "address_info": "Address Information",
      "banking_info": "Banking Information",
      "family_info": "Family Information",
      "loan_details": "Loan Details",
      "personal_info": "Personal Information"
    },
    "steps": {
      "1": "Personal Info",
      "2": "Loan Details",
      "3": "Address",
      "4": "Family",
      "5": "Banking & Documents"
    },
    "submit": "Submit Application",
    "title": "Apply Now!",
    "validation": {
      "address": "Please enter a valid address",
      "bank_account": "Invalid IBAN format",
      "email": "Invalid email format",
      "file_size": "File size must be less than %{size}MB",
      "file_type": "Invalid file type. Allowed types: %{types}",
      "max_amount": "Maximum loan amount is %{amount}€",
      "max_period": "Maximum loan period is %{period} months",
      "min_amount": "Minimum loan amount is %{amount}€",
      "min_period": "Minimum loan period is %{period} months",
      "personal_code": "Personal code must be in format 123456-12345",
      "phone": "Phone must contain only digits",
      "required": "%{field} is required",
      "terms_required": "You must agree to the terms and conditions",
      "too_long": "%{field} must be at most %{count} characters",
      "too_short": "%{field} must be at least %{count} characters"
    }
  },
  "header": {
    "logo": {
      "description": "Individual financial solutions",
      "title": "Kreditiem.lv"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "hero": {
    "cta": "Apply Now",
    "description": "Apply for financing and receive an individual offer within 24 hours!",
    "title": "Individual financing offer just for you"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    }
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский",
    "select_language": "Select language"
  },
  "loading": {
    "title": "Apply for financing and receive an individual offer within 24 hours!"
  },
  "loan_types": {
    "business": {
      "description": "Up to €250,000 for your business needs",
      "title": "Business Loans"
    },
    "car": {
      "description": "Up to €100,000 for your new vehicle",
      "title": "Car Leasing"
    },
    "consumer": {
      "description": "Up to €20,000 for personal needs",
      "title": "Consumer Loans"
    },
    "mortgage": {
      "description": "Up to €500,000 for your dream home",
      "title": "Mortgages"
    },
    "title": "Loan Types"
  },
  "loan_types_page": {
    "benefits": {
      "title": "Benefits"
    },
    "business": {
      "benefits": {
        "accessible": "Accessible - During the contract period, receive answers to questions from your consultant",
        "convenient": "Convenient - Complete the transaction remotely, without leaving home",
        "fast": "Fast - Sign the contract electronically with SMART-ID or e-Signature",
        "pause": "Pause - Possible deferred payment for up to six months",
        "profitable": "Profitable - Repay the loan faster or receive additional amount if needed",
        "quality": "Quality - Receive a payment schedule individually tailored to your business"
      },
      "description": "For existing or prospective business operators for working capital, purchase of work materials/equipment, or starting a business.",
      "details": {
        "security": "The loan is issued only with real estate security.",
        "suitable": "Business loan is a suitable solution for self-employed persons who plan to start or conduct business activities, farms, as well as entrepreneurs who need working capital."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, it is possible to repay the loan before the term.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "For urgent business matters, we can evaluate issuing part of the funding on the contract signing day.",
          "question": "Is it possible to receive part of the loan immediately?"
        },
        "purpose_check": {
          "answer": "We will ask you to inform us about the loan usage purpose.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "Up to 15 years",
      "rate": "From 9% + EURIBOR per year",
      "security": "Real Estate",
      "title": "Business Loan"
    },
    "car": {
      "benefits": {
        "accessible": "Accessible - In case of repair, the car is repaired at a freely chosen official car service",
        "convenient": "Convenient - Monthly payment includes rental fee, KASKO and OCTA"
      },
      "description": "Kredītiem.lv cooperation partners will offer you full-service car leasing for new or used cars. This service can be used by both private individuals and entrepreneurs.",
      "details": {
        "full_service": "Kredītiem.lv cooperation partners offer you full-service car leasing for new or used cars. This service can be used by both private individuals and entrepreneurs.",
        "partners": "Our cooperation partners offer various solutions, including car acquisition without down payment."
      },
      "faq": {
        "buyout": {
          "answer": "Yes, you can buy out the car or return it to the lessors.",
          "question": "Is it possible to buy out the car after 3 years of rental?"
        },
        "down_payment": {
          "answer": "Our cooperation partners offer various solutions, including car acquisition without down payment.",
          "question": "Do I need to have a down payment?"
        },
        "extension": {
          "answer": "No, you cannot extend the contract for the specific car, it must be bought out or returned to the lessor (according to the contract you conclude), but you can choose a new car and conclude a new deal.",
          "question": "Can I extend the full-service car rental after 3 years?"
        }
      },
      "period": "Up to 3 years",
      "rate": "Without down payment",
      "security": "Full service (OCTA + KASKO included)",
      "title": "Car Leasing"
    },
    "consumer": {
      "benefits": {
        "accessible": "Accessible - No collateral required, review from 15 minutes",
        "convenient": "Convenient - Quick and easy solution for urgent matters that shouldn't be postponed",
        "fast": "Fast - Application review from 15 minutes",
        "pause": "Flexible - Various repayment terms from 3 months to 10 years",
        "profitable": "Profitable - Competitive interest rates starting from 6.9%",
        "quality": "Quality - Individualized offer tailored to your situation"
      },
      "description": "Support for your plans - for larger purchases, home improvements, unexpected expenses, vacation or various situations.",
      "details": {
        "security": "No collateral required. The loan amount ranges from €100 to €20,000 with flexible repayment terms.",
        "suitable": "Consumer loan is suitable when you need to quickly and conveniently resolve issues that shouldn't be postponed. Perfect for larger purchases, home improvements, unexpected expenses, vacation, or various life situations."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, early repayment is possible without additional fees.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "You can borrow from €100 to €20,000 depending on your income and creditworthiness.",
          "question": "What is the minimum and maximum loan amount?"
        },
        "purpose_check": {
          "answer": "Consumer loan can be used for your chosen purposes - we don't restrict how you use the funds.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "3 months - 10 years",
      "rate": "From 6.9% per year",
      "security": "No collateral required",
      "title": "Consumer Loan"
    },
    "cta": {
      "button": "Apply Now",
      "description": "Start your application today and receive an individual offer within 24 hours.",
      "title": "Ready to Apply?"
    },
    "details": {
      "title": "Details"
    },
    "faq": {
      "title": "Frequently Asked Questions"
    },
    "hero": {
      "description": "Choose the financing solution that best suits your needs. We offer various loan types with competitive terms and individual approach.",
      "title": "Loan Types"
    },
    "how_to_apply": {
      "step1": {
        "description": "Complete the application form and receive an offer via email",
        "title": "Fill Application"
      },
      "step2": {
        "description": "Confirm the agreement with electronic signature or receive it by courier",
        "title": "Confirm Agreement"
      },
      "step3": {
        "description": "Receive the loan in your account and direct it to your planned purpose",
        "title": "Receive Funds"
      },
      "title": "How to Apply"
    },
    "info": {
      "period": "Period",
      "rate": "Interest Rate",
      "security": "Security"
    },
    "mortgage": {
      "benefits": {
        "accessible": "Accessible - During the contract period, receive answers to questions from your consultant",
        "convenient": "Convenient - Complete the transaction remotely, without leaving home",
        "fast": "Fast - Sign the contract electronically with SMART-ID or e-Signature",
        "pause": "Pause - Possible deferred payment for up to six months",
        "profitable": "Profitable - Repay the loan faster or receive additional amount if needed",
        "quality": "Quality - Receive a payment schedule individually tailored to your business"
      },
      "description": "Loan secured by real estate. For property acquisition, refinancing existing loans, or pledging existing property.",
      "details": {
        "evaluation": "In this case, the collateral value is determined with the help of a certified appraiser by inspecting your real estate. Primarily, first-time loan applications are reviewed within 1 business day, providing the client with a prompt response about possible loan approval.",
        "processing": "However, there are also cases when a more in-depth evaluation is needed, which can take up to 3-5 business days. In such cases, the client is informed by phone about the evaluation timeframe. The received loan is directed to the purpose specified in the application.",
        "suitable": "A mortgage is a suitable solution for individuals or legal entities who own real estate. It is a long-term transaction secured by real estate collateral. The loan is granted to the client up to 75% of the collateral value and is issued to persons who have reached at least 18 years of age."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, it is possible to repay the loan before the term.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "For urgent business matters, we can evaluate issuing part of the funding on the contract signing day.",
          "question": "Is it possible to receive part of the loan immediately?"
        },
        "purpose_check": {
          "answer": "We will ask you to inform us about the loan usage purpose.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "Up to 15 years",
      "rate": "From 9% + EURIBOR per year",
      "security": "Real Estate",
      "title": "Mortgage"
    }
  },
  "loan_use_cases": {
    "business_development": "Business Development",
    "dream_vacation": "Dream Vacation",
    "for_daily_use": "Daily Expenses",
    "new_car": "New Car",
    "perfect_home": "Perfect Home"
  },
  "meta": {
    "contact_title": "Contact Us | Kreditiem.lv",
    "description": "Apply for a loan and discover your financial possibilities today",
    "keywords": "loan, mortgage, credit, financing, business loan, consumer loan, agricultural loan",
    "loan_types_title": "Loan Types | Kreditiem.lv",
    "og_description": "Get personalized financial support with our proven financial services",
    "og_title": "Kreditiem.lv - Individual Financial Solutions",
    "title": "Credit Application"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {},
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "routes": {
    "contact": "contact",
    "loan_types": "loan-types"
  },
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  }
});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
  "about": {
    "company": {
      "description": "Independent credit broker working in your interest – we compare multiple lenders to find the most favorable offer.",
      "title": "Trusted Partner on Your Side"
    },
    "expertise": {
      "description": "No hidden terms. Clear, understandable and efficient – from application to approval.",
      "title": "Fast and Transparent Solutions"
    },
    "location": {
      "title": "How to Find Us"
    },
    "security": {
      "description": "We carefully store your information and cooperate only with licensed and verified partners.",
      "title": "Security and Confidentiality Guaranteed"
    },
    "subtitle": "We work to offer you the most suitable solution",
    "team": {
      "description": "We listen, understand and adapt – solutions based on your needs, not \"one size fits all\".",
      "title": "Individual Approach to Each Client"
    },
    "title": "About Us"
  },
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      }
    }
  },
  "anchor_links": {
    "about_us": "about-us",
    "business": "business-loan",
    "car": "car-leasing",
    "consumer": "consumer-loan",
    "contact": "contact",
    "faq": "frequently-asked-questions",
    "loan_application_form": "loan-application-form",
    "mortage": "mortgage"
  },
  "contact": {
    "additional_info": "Our team is ready to help you with any questions or concerns.",
    "address": "Bukultu iela 11, Riga, Latvia",
    "address_title": "Address",
    "company_info": {
      "address": {
        "title": "Address",
        "value": "Bukultu iela 11, Riga, Latvia"
      },
      "bank": {
        "title": "A/S \"Luminor Bank\"",
        "value": "LV47RIKO0002930366834"
      },
      "email": {
        "title": "Email",
        "value": "info@kreditiem.lv"
      },
      "hours": {
        "title": "Business Hours",
        "value": "Monday - Friday: 8:00 - 17:00"
      },
      "name": {
        "title": "A/S Baltijas investīciju attīstības fonds",
        "value": "40103550907"
      },
      "phone": {
        "title": "Phone",
        "value": "+371 251182216"
      },
      "title": "Company Information"
    },
    "copyright": "© 2024 AS Baltijas investīciju attīstības fonds. All rights reserved.",
    "cta": "Contact Us",
    "email": "info@kreditiem.lv",
    "email_title": "Email",
    "form": {
      "email": "Email",
      "message": "Message",
      "message_placeholder": "Your message...",
      "name": "Name",
      "phone": "Phone Number",
      "sending": "Sending...",
      "submit": "Send Message",
      "surname": "Surname",
      "title": "Contact Form"
    },
    "hours_title": "Business Hours",
    "hours_weekdays": "Monday - Friday: 8:00 - 17:00",
    "hours_weekend": "Saturday - Sunday: Closed",
    "messages": {
      "error": "Failed to send message. Please try again.",
      "success": "Message sent successfully!"
    },
    "phone": "+371 251182216",
    "phone_title": "Phone",
    "subtitle": "Get in touch with our team",
    "title": "Contacts"
  },
  "contact_mailer": {
    "question": "Question"
  },
  "cookie_consent": {
    "accept": "Accept All",
    "decline": "Decline",
    "message": "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
    "privacy_policy": "Read our Privacy Policy"
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "errors": {
    "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    },
    "unacceptable_request": "A supported version is expected in the Accept header.\n",
    "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
  },
  "faq": {
    "contact_text": "Still have questions? Our team is ready to help.",
    "eligibility": {
      "answer": "After a positive loan decision, funds can be credited to your account within a few hours or days – depending on the chosen lender and loan type.",
      "question": "How quickly can I receive money in my account?"
    },
    "process": {
      "answer": "Yes, in some cases a loan with collateral or guarantor can increase the chances of getting financing or getting better terms.",
      "question": "Is it possible to get a loan with a guarantor or collateral?"
    },
    "requirements": {
      "answer": "Yes, each case is evaluated individually. Some lenders also accept alternative income sources – such as self-employment or rental income.",
      "question": "Can I apply if I'm not officially employed?"
    },
    "subtitle": "Find answers to common questions about our loan process",
    "timeframe": {
      "answer": "Yes, credit history is taken into account, but we work with multiple lenders, including those that offer solutions for clients with previous late payment marks.",
      "question": "Does my credit rating affect the chances of getting a loan?"
    },
    "title": "Frequently Asked Questions"
  },
  "features": {
    "description": "We help find not only the best lender but also make the whole process fast, clear and secure – so the result truly matches your needs.",
    "flexible_terms": {
      "description": "Choose the most convenient term yourself",
      "title": "Flexible Terms"
    },
    "great_rates": {
      "description": "Choose what suits you best",
      "title": "Transparency"
    },
    "personal_support": {
      "description": "Knowledgeable credit specialists who will help",
      "title": "Personal Support"
    },
    "quick_approval": {
      "description": "Get a response within 1 business day",
      "title": "Quick Approval"
    },
    "quick_process": {
      "description": "Get a decision within 1 business day",
      "title": "Quick Process"
    },
    "secure_process": {
      "description": "Your data is protected with highest level security",
      "title": "Secure Process"
    },
    "title": "Why Choose Us?"
  },
  "floating_button": {
    "aria_label": "Go to loan application form",
    "text": "Apply Now"
  },
  "footer": {
    "business_hours": {
      "title": "Business Hours",
      "weekdays": "Monday - Friday: 8:00 - 17:00",
      "weekend": "Saturday - Sunday: Closed"
    },
    "contact": {
      "address": "Bukultu iela 11, Riga, Latvia",
      "address_title": "Address",
      "email": "info@kreditiem.lv",
      "email_title": "Email",
      "phone": "+371 25182216",
      "phone_title": "Phone",
      "subtitle": "Get in touch with our team",
      "title": "Contact Us"
    },
    "copyright": "© %{year} AS Baltijas investīciju un attīstības fonds. All rights reserved.",
    "disclaimer": "Scope of authority - independent broker.",
    "legal": {
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "title": "Legal Information"
    },
    "quick_links": {
      "about": "About Us",
      "contact": "Contact",
      "faq": "FAQ",
      "services": "Services",
      "title": "Quick Links"
    },
    "social": {
      "title": "Find Us On"
    }
  },
  "form": {
    "and": "and",
    "buttons": {
      "next": "Next",
      "previous": "Previous"
    },
    "documents_help": "To evaluate your application, please attach bank statements for the last 6 months.",
    "family_status": {
      "married": "Married",
      "single": "Single"
    },
    "fields": {
      "addresses_match": "My factual address matches the declared address",
      "agree_to_terms": "I agree to",
      "bank_account": "Bank Account Number (IBAN)",
      "city": "City / Town",
      "declared_address": "Declared Address",
      "dependent_persons": "Number of Dependent Persons",
      "email": "Email",
      "factical_address": "Factual Address",
      "family_status": "Family Status",
      "first_name": "First Name",
      "job_type": "Employment Type",
      "last_name": "Last Name",
      "loan_amount": "Loan Amount",
      "loan_period": "Loan Period",
      "loan_type": "Loan Type",
      "personal_code": "Personal Code",
      "phone": "Phone Number",
      "upload_documents": "For faster application processing, attach bank account statement"
    },
    "job_type": {
      "other": "Other",
      "permanent": "Permanent Work",
      "retired": "Retired",
      "self_employed": "Self-employed",
      "student": "Student",
      "temporary": "Temporary Work",
      "unemployed": "Unemployed"
    },
    "links": {
      "privacy_policy": "Privacy Policy",
      "terms": "Terms of Service"
    },
    "loan_types": {
      "business": "Business Loan",
      "car": "Car Leasing",
      "consumer": "Consumer Loan",
      "mortgage": "Mortgage"
    },
    "messages": {
      "error": "Error submitting application: %{message}",
      "file_upload_error": "Error uploading file: %{message}",
      "file_upload_max": "Maximum number of files reached",
      "file_upload_removed": "File removed",
      "file_upload_size": "File size exceeds limit",
      "file_upload_success": "File uploaded successfully",
      "file_upload_type": "Invalid file type",
      "loading": "Loading...",
      "network_error": "Network error. Please try again.",
      "processing": "Processing your application...",
      "saving": "Saving...",
      "success": "Application submitted successfully!",
      "success_subtitle": "We will contact you shortly",
      "uploading": "Uploading..."
    },
    "months": "months",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Enter your city",
      "personal_code": "123456-12345",
      "phone": "+371 12345678"
    },
    "sections": {
      "address_info": "Address Information",
      "banking_info": "Banking Information",
      "family_info": "Family Information",
      "loan_details": "Loan Details",
      "personal_info": "Personal Information"
    },
    "steps": {
      "1": "Personal Info",
      "2": "Loan Details",
      "3": "Address",
      "4": "Family",
      "5": "Banking & Documents"
    },
    "submit": "Submit Application",
    "title": "Apply Now!",
    "validation": {
      "address": "Please enter a valid address",
      "bank_account": "Invalid IBAN format",
      "email": "Invalid email format",
      "file_size": "File size must be less than %{size}MB",
      "file_type": "Invalid file type. Allowed types: %{types}",
      "max_amount": "Maximum loan amount is %{amount}€",
      "max_period": "Maximum loan period is %{period} months",
      "min_amount": "Minimum loan amount is %{amount}€",
      "min_period": "Minimum loan period is %{period} months",
      "personal_code": "Personal code must be in format 123456-12345",
      "phone": "Phone must contain only digits",
      "required": "%{field} is required",
      "terms_required": "You must agree to the terms and conditions",
      "too_long": "%{field} must be at most %{count} characters",
      "too_short": "%{field} must be at least %{count} characters"
    }
  },
  "header": {
    "logo": {
      "description": "Individual financial solutions",
      "title": "Kreditiem.lv"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "hero": {
    "cta": "Apply Now",
    "description": "Apply for financing and receive an individual offer within 24 hours!",
    "title": "Individual financing offer just for you"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    }
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский",
    "select_language": "Select language"
  },
  "loading": {
    "title": "Apply for financing and receive an individual offer within 24 hours!"
  },
  "loan_types": {
    "business": {
      "description": "Up to €250,000 for your business needs",
      "title": "Business Loans"
    },
    "car": {
      "description": "Up to €100,000 for your new vehicle",
      "title": "Car Leasing"
    },
    "consumer": {
      "description": "Up to €20,000 for personal needs",
      "title": "Consumer Loans"
    },
    "mortgage": {
      "description": "Up to €500,000 for your dream home",
      "title": "Mortgages"
    },
    "title": "Loan Types"
  },
  "loan_types_page": {
    "benefits": {
      "title": "Benefits"
    },
    "business": {
      "benefits": {
        "accessible": "Accessible - During the contract period, receive answers to questions from your consultant",
        "convenient": "Convenient - Complete the transaction remotely, without leaving home",
        "fast": "Fast - Sign the contract electronically with SMART-ID or e-Signature",
        "pause": "Pause - Possible deferred payment for up to six months",
        "profitable": "Profitable - Repay the loan faster or receive additional amount if needed",
        "quality": "Quality - Receive a payment schedule individually tailored to your business"
      },
      "description": "For existing or prospective business operators for working capital, purchase of work materials/equipment, or starting a business.",
      "details": {
        "security": "The loan is issued only with real estate security.",
        "suitable": "Business loan is a suitable solution for self-employed persons who plan to start or conduct business activities, farms, as well as entrepreneurs who need working capital."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, it is possible to repay the loan before the term.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "For urgent business matters, we can evaluate issuing part of the funding on the contract signing day.",
          "question": "Is it possible to receive part of the loan immediately?"
        },
        "purpose_check": {
          "answer": "We will ask you to inform us about the loan usage purpose.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "Up to 15 years",
      "rate": "From 9% + EURIBOR per year",
      "security": "Real Estate",
      "title": "Business Loan"
    },
    "car": {
      "benefits": {
        "accessible": "Accessible - In case of repair, the car is repaired at a freely chosen official car service",
        "convenient": "Convenient - Monthly payment includes rental fee, KASKO and OCTA"
      },
      "description": "Kredītiem.lv cooperation partners will offer you full-service car leasing for new or used cars. This service can be used by both private individuals and entrepreneurs.",
      "details": {
        "full_service": "Kredītiem.lv cooperation partners offer you full-service car leasing for new or used cars. This service can be used by both private individuals and entrepreneurs.",
        "partners": "Our cooperation partners offer various solutions, including car acquisition without down payment."
      },
      "faq": {
        "buyout": {
          "answer": "Yes, you can buy out the car or return it to the lessors.",
          "question": "Is it possible to buy out the car after 3 years of rental?"
        },
        "down_payment": {
          "answer": "Our cooperation partners offer various solutions, including car acquisition without down payment.",
          "question": "Do I need to have a down payment?"
        },
        "extension": {
          "answer": "No, you cannot extend the contract for the specific car, it must be bought out or returned to the lessor (according to the contract you conclude), but you can choose a new car and conclude a new deal.",
          "question": "Can I extend the full-service car rental after 3 years?"
        }
      },
      "period": "Up to 3 years",
      "rate": "Without down payment",
      "security": "Full service (OCTA + KASKO included)",
      "title": "Car Leasing"
    },
    "consumer": {
      "benefits": {
        "accessible": "Accessible - No collateral required, review from 15 minutes",
        "convenient": "Convenient - Quick and easy solution for urgent matters that shouldn't be postponed",
        "fast": "Fast - Application review from 15 minutes",
        "pause": "Flexible - Various repayment terms from 3 months to 10 years",
        "profitable": "Profitable - Competitive interest rates starting from 6.9%",
        "quality": "Quality - Individualized offer tailored to your situation"
      },
      "description": "Support for your plans - for larger purchases, home improvements, unexpected expenses, vacation or various situations.",
      "details": {
        "security": "No collateral required. The loan amount ranges from €100 to €20,000 with flexible repayment terms.",
        "suitable": "Consumer loan is suitable when you need to quickly and conveniently resolve issues that shouldn't be postponed. Perfect for larger purchases, home improvements, unexpected expenses, vacation, or various life situations."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, early repayment is possible without additional fees.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "You can borrow from €100 to €20,000 depending on your income and creditworthiness.",
          "question": "What is the minimum and maximum loan amount?"
        },
        "purpose_check": {
          "answer": "Consumer loan can be used for your chosen purposes - we don't restrict how you use the funds.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "3 months - 10 years",
      "rate": "From 6.9% per year",
      "security": "No collateral required",
      "title": "Consumer Loan"
    },
    "cta": {
      "button": "Apply Now",
      "description": "Start your application today and receive an individual offer within 24 hours.",
      "title": "Ready to Apply?"
    },
    "details": {
      "title": "Details"
    },
    "faq": {
      "title": "Frequently Asked Questions"
    },
    "hero": {
      "description": "Choose the financing solution that best suits your needs. We offer various loan types with competitive terms and individual approach.",
      "title": "Loan Types"
    },
    "how_to_apply": {
      "step1": {
        "description": "Complete the application form and receive an offer via email",
        "title": "Fill Application"
      },
      "step2": {
        "description": "Confirm the agreement with electronic signature or receive it by courier",
        "title": "Confirm Agreement"
      },
      "step3": {
        "description": "Receive the loan in your account and direct it to your planned purpose",
        "title": "Receive Funds"
      },
      "title": "How to Apply"
    },
    "info": {
      "period": "Period",
      "rate": "Interest Rate",
      "security": "Security"
    },
    "mortgage": {
      "benefits": {
        "accessible": "Accessible - During the contract period, receive answers to questions from your consultant",
        "convenient": "Convenient - Complete the transaction remotely, without leaving home",
        "fast": "Fast - Sign the contract electronically with SMART-ID or e-Signature",
        "pause": "Pause - Possible deferred payment for up to six months",
        "profitable": "Profitable - Repay the loan faster or receive additional amount if needed",
        "quality": "Quality - Receive a payment schedule individually tailored to your business"
      },
      "description": "Loan secured by real estate. For property acquisition, refinancing existing loans, or pledging existing property.",
      "details": {
        "evaluation": "In this case, the collateral value is determined with the help of a certified appraiser by inspecting your real estate. Primarily, first-time loan applications are reviewed within 1 business day, providing the client with a prompt response about possible loan approval.",
        "processing": "However, there are also cases when a more in-depth evaluation is needed, which can take up to 3-5 business days. In such cases, the client is informed by phone about the evaluation timeframe. The received loan is directed to the purpose specified in the application.",
        "suitable": "A mortgage is a suitable solution for individuals or legal entities who own real estate. It is a long-term transaction secured by real estate collateral. The loan is granted to the client up to 75% of the collateral value and is issued to persons who have reached at least 18 years of age."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, it is possible to repay the loan before the term.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "For urgent business matters, we can evaluate issuing part of the funding on the contract signing day.",
          "question": "Is it possible to receive part of the loan immediately?"
        },
        "purpose_check": {
          "answer": "We will ask you to inform us about the loan usage purpose.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "Up to 15 years",
      "rate": "From 9% + EURIBOR per year",
      "security": "Real Estate",
      "title": "Mortgage"
    }
  },
  "loan_use_cases": {
    "business_development": "Business Development",
    "dream_vacation": "Dream Vacation",
    "for_daily_use": "Daily Expenses",
    "new_car": "New Car",
    "perfect_home": "Perfect Home"
  },
  "meta": {
    "contact_title": "Contact Us | Kreditiem.lv",
    "description": "Apply for a loan and discover your financial possibilities today",
    "keywords": "loan, mortgage, credit, financing, business loan, consumer loan, agricultural loan",
    "loan_types_title": "Loan Types | Kreditiem.lv",
    "og_description": "Get personalized financial support with our proven financial services",
    "og_title": "Kreditiem.lv - Individual Financial Solutions",
    "title": "Credit Application"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {},
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "routes": {
    "contact": "contact",
    "loan_types": "loan-types"
  },
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  }
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
  "about": {
    "company": {
      "description": "Independent credit broker working in your interest – we compare multiple lenders to find the most favorable offer.",
      "title": "Trusted Partner on Your Side"
    },
    "expertise": {
      "description": "No hidden terms. Clear, understandable and efficient – from application to approval.",
      "title": "Fast and Transparent Solutions"
    },
    "location": {
      "title": "How to Find Us"
    },
    "security": {
      "description": "We carefully store your information and cooperate only with licensed and verified partners.",
      "title": "Security and Confidentiality Guaranteed"
    },
    "subtitle": "We work to offer you the most suitable solution",
    "team": {
      "description": "We listen, understand and adapt – solutions based on your needs, not \"one size fits all\".",
      "title": "Individual Approach to Each Client"
    },
    "title": "About Us"
  },
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Validation failed: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Cannot delete record because dependent %{record} exist",
          "has_one": "Cannot delete record because a dependent %{record} exists"
        }
      }
    }
  },
  "anchor_links": {
    "about_us": "about-us",
    "business": "business-loan",
    "car": "car-leasing",
    "consumer": "consumer-loan",
    "contact": "contact",
    "faq": "frequently-asked-questions",
    "loan_application_form": "loan-application-form",
    "mortage": "mortgage"
  },
  "contact": {
    "additional_info": "Our team is ready to help you with any questions or concerns.",
    "address": "Bukultu iela 11, Riga, Latvia",
    "address_title": "Address",
    "company_info": {
      "address": {
        "title": "Address",
        "value": "Bukultu iela 11, Riga, Latvia"
      },
      "bank": {
        "title": "A/S \"Luminor Bank\"",
        "value": "LV47RIKO0002930366834"
      },
      "email": {
        "title": "Email",
        "value": "info@kreditiem.lv"
      },
      "hours": {
        "title": "Business Hours",
        "value": "Monday - Friday: 8:00 - 17:00"
      },
      "name": {
        "title": "A/S Baltijas investīciju attīstības fonds",
        "value": "40103550907"
      },
      "phone": {
        "title": "Phone",
        "value": "+371 251182216"
      },
      "title": "Company Information"
    },
    "copyright": "© 2024 AS Baltijas investīciju attīstības fonds. All rights reserved.",
    "cta": "Contact Us",
    "email": "info@kreditiem.lv",
    "email_title": "Email",
    "form": {
      "email": "Email",
      "message": "Message",
      "message_placeholder": "Your message...",
      "name": "Name",
      "phone": "Phone Number",
      "sending": "Sending...",
      "submit": "Send Message",
      "surname": "Surname",
      "title": "Contact Form"
    },
    "hours_title": "Business Hours",
    "hours_weekdays": "Monday - Friday: 8:00 - 17:00",
    "hours_weekend": "Saturday - Sunday: Closed",
    "messages": {
      "error": "Failed to send message. Please try again.",
      "success": "Message sent successfully!"
    },
    "phone": "+371 251182216",
    "phone_title": "Phone",
    "subtitle": "Get in touch with our team",
    "title": "Contacts"
  },
  "contact_mailer": {
    "question": "Question"
  },
  "cookie_consent": {
    "accept": "Accept All",
    "decline": "Decline",
    "message": "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
    "privacy_policy": "Read our Privacy Policy"
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about %{count} hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about %{count} month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about %{count} year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost %{count} year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than %{count} second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over %{count} year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "%{count} day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "%{count} minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "%{count} month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "%{count} second",
        "other": "%{count} seconds"
      },
      "x_years": {
        "one": "%{count} year",
        "other": "%{count} years"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Second",
      "year": "Year"
    }
  },
  "errors": {
    "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "must be accepted",
      "blank": "can't be blank",
      "confirmation": "doesn't match %{attribute}",
      "empty": "can't be empty",
      "equal_to": "must be equal to %{count}",
      "even": "must be even",
      "exclusion": "is reserved",
      "greater_than": "must be greater than %{count}",
      "greater_than_or_equal_to": "must be greater than or equal to %{count}",
      "in": "must be in %{count}",
      "inclusion": "is not included in the list",
      "invalid": "is invalid",
      "less_than": "must be less than %{count}",
      "less_than_or_equal_to": "must be less than or equal to %{count}",
      "model_invalid": "Validation failed: %{errors}",
      "not_a_number": "is not a number",
      "not_an_integer": "must be an integer",
      "odd": "must be odd",
      "other_than": "must be other than %{count}",
      "password_too_long": "is too long",
      "present": "must be blank",
      "required": "must exist",
      "taken": "has already been taken",
      "too_long": {
        "one": "is too long (maximum is %{count} character)",
        "other": "is too long (maximum is %{count} characters)"
      },
      "too_short": {
        "one": "is too short (minimum is %{count} character)",
        "other": "is too short (minimum is %{count} characters)"
      },
      "wrong_length": {
        "one": "is the wrong length (should be %{count} character)",
        "other": "is the wrong length (should be %{count} characters)"
      }
    },
    "template": {
      "body": "There were problems with the following fields:",
      "header": {
        "one": "%{count} error prohibited this %{model} from being saved",
        "other": "%{count} errors prohibited this %{model} from being saved"
      }
    },
    "unacceptable_request": "A supported version is expected in the Accept header.\n",
    "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
  },
  "faq": {
    "contact_text": "Still have questions? Our team is ready to help.",
    "eligibility": {
      "answer": "After a positive loan decision, funds can be credited to your account within a few hours or days – depending on the chosen lender and loan type.",
      "question": "How quickly can I receive money in my account?"
    },
    "process": {
      "answer": "Yes, in some cases a loan with collateral or guarantor can increase the chances of getting financing or getting better terms.",
      "question": "Is it possible to get a loan with a guarantor or collateral?"
    },
    "requirements": {
      "answer": "Yes, each case is evaluated individually. Some lenders also accept alternative income sources – such as self-employment or rental income.",
      "question": "Can I apply if I'm not officially employed?"
    },
    "subtitle": "Find answers to common questions about our loan process",
    "timeframe": {
      "answer": "Yes, credit history is taken into account, but we work with multiple lenders, including those that offer solutions for clients with previous late payment marks.",
      "question": "Does my credit rating affect the chances of getting a loan?"
    },
    "title": "Frequently Asked Questions"
  },
  "features": {
    "description": "We help find not only the best lender but also make the whole process fast, clear and secure – so the result truly matches your needs.",
    "flexible_terms": {
      "description": "Choose the most convenient term yourself",
      "title": "Flexible Terms"
    },
    "great_rates": {
      "description": "Choose what suits you best",
      "title": "Transparency"
    },
    "personal_support": {
      "description": "Knowledgeable credit specialists who will help",
      "title": "Personal Support"
    },
    "quick_approval": {
      "description": "Get a response within 1 business day",
      "title": "Quick Approval"
    },
    "quick_process": {
      "description": "Get a decision within 1 business day",
      "title": "Quick Process"
    },
    "secure_process": {
      "description": "Your data is protected with highest level security",
      "title": "Secure Process"
    },
    "title": "Why Choose Us?"
  },
  "floating_button": {
    "aria_label": "Go to loan application form",
    "text": "Apply Now"
  },
  "footer": {
    "business_hours": {
      "title": "Business Hours",
      "weekdays": "Monday - Friday: 8:00 - 17:00",
      "weekend": "Saturday - Sunday: Closed"
    },
    "contact": {
      "address": "Bukultu iela 11, Riga, Latvia",
      "address_title": "Address",
      "email": "info@kreditiem.lv",
      "email_title": "Email",
      "phone": "+371 25182216",
      "phone_title": "Phone",
      "subtitle": "Get in touch with our team",
      "title": "Contact Us"
    },
    "copyright": "© %{year} AS Baltijas investīciju un attīstības fonds. All rights reserved.",
    "disclaimer": "Scope of authority - independent broker.",
    "legal": {
      "privacy": "Privacy Policy",
      "terms": "Terms of Service",
      "title": "Legal Information"
    },
    "quick_links": {
      "about": "About Us",
      "contact": "Contact",
      "faq": "FAQ",
      "services": "Services",
      "title": "Quick Links"
    },
    "social": {
      "title": "Find Us On"
    }
  },
  "form": {
    "and": "and",
    "buttons": {
      "next": "Next",
      "previous": "Previous"
    },
    "documents_help": "To evaluate your application, please attach bank statements for the last 6 months.",
    "family_status": {
      "married": "Married",
      "single": "Single"
    },
    "fields": {
      "addresses_match": "My factual address matches the declared address",
      "agree_to_terms": "I agree to",
      "bank_account": "Bank Account Number (IBAN)",
      "city": "City / Town",
      "declared_address": "Declared Address",
      "dependent_persons": "Number of Dependent Persons",
      "email": "Email",
      "factical_address": "Factual Address",
      "family_status": "Family Status",
      "first_name": "First Name",
      "job_type": "Employment Type",
      "last_name": "Last Name",
      "loan_amount": "Loan Amount",
      "loan_period": "Loan Period",
      "loan_type": "Loan Type",
      "personal_code": "Personal Code",
      "phone": "Phone Number",
      "upload_documents": "For faster application processing, attach bank account statement"
    },
    "job_type": {
      "other": "Other",
      "permanent": "Permanent Work",
      "retired": "Retired",
      "self_employed": "Self-employed",
      "student": "Student",
      "temporary": "Temporary Work",
      "unemployed": "Unemployed"
    },
    "links": {
      "privacy_policy": "Privacy Policy",
      "terms": "Terms of Service"
    },
    "loan_types": {
      "business": "Business Loan",
      "car": "Car Leasing",
      "consumer": "Consumer Loan",
      "mortgage": "Mortgage"
    },
    "messages": {
      "error": "Error submitting application: %{message}",
      "file_upload_error": "Error uploading file: %{message}",
      "file_upload_max": "Maximum number of files reached",
      "file_upload_removed": "File removed",
      "file_upload_size": "File size exceeds limit",
      "file_upload_success": "File uploaded successfully",
      "file_upload_type": "Invalid file type",
      "loading": "Loading...",
      "network_error": "Network error. Please try again.",
      "processing": "Processing your application...",
      "saving": "Saving...",
      "success": "Application submitted successfully!",
      "success_subtitle": "We will contact you shortly",
      "uploading": "Uploading..."
    },
    "months": "months",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Enter your city",
      "personal_code": "123456-12345",
      "phone": "+371 12345678"
    },
    "sections": {
      "address_info": "Address Information",
      "banking_info": "Banking Information",
      "family_info": "Family Information",
      "loan_details": "Loan Details",
      "personal_info": "Personal Information"
    },
    "steps": {
      "1": "Personal Info",
      "2": "Loan Details",
      "3": "Address",
      "4": "Family",
      "5": "Banking & Documents"
    },
    "submit": "Submit Application",
    "title": "Apply Now!",
    "validation": {
      "address": "Please enter a valid address",
      "bank_account": "Invalid IBAN format",
      "email": "Invalid email format",
      "file_size": "File size must be less than %{size}MB",
      "file_type": "Invalid file type. Allowed types: %{types}",
      "max_amount": "Maximum loan amount is %{amount}€",
      "max_period": "Maximum loan period is %{period} months",
      "min_amount": "Minimum loan amount is %{amount}€",
      "min_period": "Minimum loan period is %{period} months",
      "personal_code": "Personal code must be in format 123456-12345",
      "phone": "Phone must contain only digits",
      "required": "%{field} is required",
      "terms_required": "You must agree to the terms and conditions",
      "too_long": "%{field} must be at most %{count} characters",
      "too_short": "%{field} must be at least %{count} characters"
    }
  },
  "header": {
    "logo": {
      "description": "Individual financial solutions",
      "title": "Kreditiem.lv"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "hero": {
    "cta": "Apply Now",
    "description": "Apply for financing and receive an individual offer within 24 hours!",
    "title": "Individual financing offer just for you"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    }
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский",
    "select_language": "Select language"
  },
  "loading": {
    "title": "Apply for financing and receive an individual offer within 24 hours!"
  },
  "loan_types": {
    "business": {
      "description": "Up to €250,000 for your business needs",
      "title": "Business Loans"
    },
    "car": {
      "description": "Up to €100,000 for your new vehicle",
      "title": "Car Leasing"
    },
    "consumer": {
      "description": "Up to €20,000 for personal needs",
      "title": "Consumer Loans"
    },
    "mortgage": {
      "description": "Up to €500,000 for your dream home",
      "title": "Mortgages"
    },
    "title": "Loan Types"
  },
  "loan_types_page": {
    "benefits": {
      "title": "Benefits"
    },
    "business": {
      "benefits": {
        "accessible": "Accessible - During the contract period, receive answers to questions from your consultant",
        "convenient": "Convenient - Complete the transaction remotely, without leaving home",
        "fast": "Fast - Sign the contract electronically with SMART-ID or e-Signature",
        "pause": "Pause - Possible deferred payment for up to six months",
        "profitable": "Profitable - Repay the loan faster or receive additional amount if needed",
        "quality": "Quality - Receive a payment schedule individually tailored to your business"
      },
      "description": "For existing or prospective business operators for working capital, purchase of work materials/equipment, or starting a business.",
      "details": {
        "security": "The loan is issued only with real estate security.",
        "suitable": "Business loan is a suitable solution for self-employed persons who plan to start or conduct business activities, farms, as well as entrepreneurs who need working capital."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, it is possible to repay the loan before the term.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "For urgent business matters, we can evaluate issuing part of the funding on the contract signing day.",
          "question": "Is it possible to receive part of the loan immediately?"
        },
        "purpose_check": {
          "answer": "We will ask you to inform us about the loan usage purpose.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "Up to 15 years",
      "rate": "From 9% + EURIBOR per year",
      "security": "Real Estate",
      "title": "Business Loan"
    },
    "car": {
      "benefits": {
        "accessible": "Accessible - In case of repair, the car is repaired at a freely chosen official car service",
        "convenient": "Convenient - Monthly payment includes rental fee, KASKO and OCTA"
      },
      "description": "Kredītiem.lv cooperation partners will offer you full-service car leasing for new or used cars. This service can be used by both private individuals and entrepreneurs.",
      "details": {
        "full_service": "Kredītiem.lv cooperation partners offer you full-service car leasing for new or used cars. This service can be used by both private individuals and entrepreneurs.",
        "partners": "Our cooperation partners offer various solutions, including car acquisition without down payment."
      },
      "faq": {
        "buyout": {
          "answer": "Yes, you can buy out the car or return it to the lessors.",
          "question": "Is it possible to buy out the car after 3 years of rental?"
        },
        "down_payment": {
          "answer": "Our cooperation partners offer various solutions, including car acquisition without down payment.",
          "question": "Do I need to have a down payment?"
        },
        "extension": {
          "answer": "No, you cannot extend the contract for the specific car, it must be bought out or returned to the lessor (according to the contract you conclude), but you can choose a new car and conclude a new deal.",
          "question": "Can I extend the full-service car rental after 3 years?"
        }
      },
      "period": "Up to 3 years",
      "rate": "Without down payment",
      "security": "Full service (OCTA + KASKO included)",
      "title": "Car Leasing"
    },
    "consumer": {
      "benefits": {
        "accessible": "Accessible - No collateral required, review from 15 minutes",
        "convenient": "Convenient - Quick and easy solution for urgent matters that shouldn't be postponed",
        "fast": "Fast - Application review from 15 minutes",
        "pause": "Flexible - Various repayment terms from 3 months to 10 years",
        "profitable": "Profitable - Competitive interest rates starting from 6.9%",
        "quality": "Quality - Individualized offer tailored to your situation"
      },
      "description": "Support for your plans - for larger purchases, home improvements, unexpected expenses, vacation or various situations.",
      "details": {
        "security": "No collateral required. The loan amount ranges from €100 to €20,000 with flexible repayment terms.",
        "suitable": "Consumer loan is suitable when you need to quickly and conveniently resolve issues that shouldn't be postponed. Perfect for larger purchases, home improvements, unexpected expenses, vacation, or various life situations."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, early repayment is possible without additional fees.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "You can borrow from €100 to €20,000 depending on your income and creditworthiness.",
          "question": "What is the minimum and maximum loan amount?"
        },
        "purpose_check": {
          "answer": "Consumer loan can be used for your chosen purposes - we don't restrict how you use the funds.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "3 months - 10 years",
      "rate": "From 6.9% per year",
      "security": "No collateral required",
      "title": "Consumer Loan"
    },
    "cta": {
      "button": "Apply Now",
      "description": "Start your application today and receive an individual offer within 24 hours.",
      "title": "Ready to Apply?"
    },
    "details": {
      "title": "Details"
    },
    "faq": {
      "title": "Frequently Asked Questions"
    },
    "hero": {
      "description": "Choose the financing solution that best suits your needs. We offer various loan types with competitive terms and individual approach.",
      "title": "Loan Types"
    },
    "how_to_apply": {
      "step1": {
        "description": "Complete the application form and receive an offer via email",
        "title": "Fill Application"
      },
      "step2": {
        "description": "Confirm the agreement with electronic signature or receive it by courier",
        "title": "Confirm Agreement"
      },
      "step3": {
        "description": "Receive the loan in your account and direct it to your planned purpose",
        "title": "Receive Funds"
      },
      "title": "How to Apply"
    },
    "info": {
      "period": "Period",
      "rate": "Interest Rate",
      "security": "Security"
    },
    "mortgage": {
      "benefits": {
        "accessible": "Accessible - During the contract period, receive answers to questions from your consultant",
        "convenient": "Convenient - Complete the transaction remotely, without leaving home",
        "fast": "Fast - Sign the contract electronically with SMART-ID or e-Signature",
        "pause": "Pause - Possible deferred payment for up to six months",
        "profitable": "Profitable - Repay the loan faster or receive additional amount if needed",
        "quality": "Quality - Receive a payment schedule individually tailored to your business"
      },
      "description": "Loan secured by real estate. For property acquisition, refinancing existing loans, or pledging existing property.",
      "details": {
        "evaluation": "In this case, the collateral value is determined with the help of a certified appraiser by inspecting your real estate. Primarily, first-time loan applications are reviewed within 1 business day, providing the client with a prompt response about possible loan approval.",
        "processing": "However, there are also cases when a more in-depth evaluation is needed, which can take up to 3-5 business days. In such cases, the client is informed by phone about the evaluation timeframe. The received loan is directed to the purpose specified in the application.",
        "suitable": "A mortgage is a suitable solution for individuals or legal entities who own real estate. It is a long-term transaction secured by real estate collateral. The loan is granted to the client up to 75% of the collateral value and is issued to persons who have reached at least 18 years of age."
      },
      "faq": {
        "early_repayment": {
          "answer": "Yes, it is possible to repay the loan before the term.",
          "question": "Is it possible to repay the loan early?"
        },
        "partial_funding": {
          "answer": "For urgent business matters, we can evaluate issuing part of the funding on the contract signing day.",
          "question": "Is it possible to receive part of the loan immediately?"
        },
        "purpose_check": {
          "answer": "We will ask you to inform us about the loan usage purpose.",
          "question": "Will the loan usage purpose be checked?"
        }
      },
      "period": "Up to 15 years",
      "rate": "From 9% + EURIBOR per year",
      "security": "Real Estate",
      "title": "Mortgage"
    }
  },
  "loan_use_cases": {
    "business_development": "Business Development",
    "dream_vacation": "Dream Vacation",
    "for_daily_use": "Daily Expenses",
    "new_car": "New Car",
    "perfect_home": "Perfect Home"
  },
  "meta": {
    "contact_title": "Contact Us | Kreditiem.lv",
    "description": "Apply for a loan and discover your financial possibilities today",
    "keywords": "loan, mortgage, credit, financing, business loan, consumer loan, agricultural loan",
    "loan_types_title": "Loan Types | Kreditiem.lv",
    "og_description": "Get personalized financial support with our proven financial services",
    "og_title": "Kreditiem.lv - Individual Financial Solutions",
    "title": "Credit Application"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "negative_format": "-%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB",
          "zb": "ZB"
        }
      }
    },
    "nth": {},
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "routes": {
    "contact": "contact",
    "loan_types": "loan-types"
  },
  "support": {
    "array": {
      "last_word_connector": ", and ",
      "two_words_connector": " and ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M"
    },
    "pm": "pm"
  }
});
